module.exports = __webpack_public_path__ + "images/psp/CarStorage/car-related4.jpg";